/**
 * @file: index.tsx
 *
 * `ChatSearchScreen` — the navigator binding for chat search: it mounts
 * `ChatSearchView` and maps the picked thread/contact to a conversation
 * intent, opening it. The conversation is a ROOT-stack surface (`_chat`), so
 * the pick dismisses this screen and pushes the chat flow — the pair adds up
 * to the `replace` this used to do inside one stack. The view itself
 * (re-exported here) is navigation-agnostic and lives in `./components`.
 */

import {
  conversationIntentForContact,
  conversationIntentForThread,
} from '@euler/app/flows/chat/lib/conversation/types';
import { useOpenChatConversation } from '@euler/app/flows/chat/lib/navigation/openChatConversation';
import { useChatSession } from '@euler/app/flows/chat/lib/session/context';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import { ChatSearchView } from './components/ChatSearchView';

export { ChatSearchView };

export const ChatSearchScreen = wrapNavigatorScreen(
  () => {
    const navigation = useNavigation();
    const openConversation = useOpenChatConversation();
    const { me } = useChatSession();
    const selfName = me.user.name;
    return (
      <ChatSearchView
        onCancel={() => navigation.goBack()}
        onPick={pick => {
          const intent =
            pick.kind === 'thread'
              ? conversationIntentForThread(pick.thread, selfName)
              : conversationIntentForContact(pick.contact);
          navigation.goBack();
          openConversation(intent);
        }}
      />
    );
  },
  { headerShown: false },
);
